/** API for the shared design descriptor referenced by a PlayEngine version. */

import { getServerUri } from "./uriUtility";

async function postJson(servicePath, payload) {
  const response = await fetch(getServerUri(servicePath), {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({
      accessToken: localStorage.getItem("session.accessToken"),
      ...payload,
    }),
  });

  const contentType = response.headers.get("content-type") || "";
  const body = contentType.includes("application/json")
    ? await response.json()
    : await response.text();

  return response.ok
    ? { ok: true, status: response.status, data: body }
    : { ok: false, status: response.status, error: body };
}

export function getPlayEngineDesign(versionID) {
  return postJson("versionPlayEngine/getDesign", { versionID: String(versionID) });
}

export function savePlayEngineDesign(versionID, { designId, design, contentHash }) {
  return postJson("versionPlayEngine/saveDesign", {
    versionID: String(versionID),
    ...(designId ? { designId } : {}),
    design,
    ...(contentHash ? { contentHash } : {}),
  });
}
